import React from 'react'
import OrganisationList from 'src/components/organisms/OrganisationList'

export const Organisations = () => <OrganisationList />

export default Organisations
